module.exports = __webpack_public_path__ + "assets/pie_us-231e41.svg";